import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GlassPaper = styled(Paper)(({ theme }) => ({
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        background: 'rgba(255, 255, 255, 0.8)',
    },
}));

export const FeatureRequestBox = styled(Box)(({ theme }) => ({
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 2,
    marginBottom: theme.spacing(4),
}));

export const ContactButton = {
    alignSelf: 'flex-start',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    '&:hover': {
        background: 'linear-gradient(45deg, #1976D2 30%, #1E88E5 90%)',
    },
}; 